import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCheckCircle = () => {
  return (
    <g>
      <path d="M8.976.06a7.97 7.97 0 0 1 3.447 1.272.75.75 0 0 1-.83 1.25 6.5 6.5 0 1 0 2.877 4.775.75.75 0 1 1 1.493-.147A8 8 0 1 1 8.976.06zm6.807 2.658a.72.72 0 0 1 .069.955l-.073.082-7.263 7.033a.766.766 0 0 1-.98.067l-.083-.071-3.234-3.18a.72.72 0 0 1 .004-1.037.766.766 0 0 1 .979-.068l.084.072L7.99 9.23l6.73-6.516a.765.765 0 0 1 1.063.004z" />
    </g>
  );
};

export default withIcon(IconCheckCircle);
